import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Actionbutton } from 'src/app/shared/common/Actionbutton';
import { CommonService } from 'src/app/shared/services/common.service';
import { JsignalService } from 'src/app/shared/services/jsignal.service';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { UserRoutingModule } from '../../user-routing/user-routing.module';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { validationmethod } from 'src/app/shared/models/validationmethod';
import { ReleaseLibraryComponent } from '../release-library.component';
import { constants } from "src/app/shared/common/contants";

@Component({
  selector: 'app-release-library-popup',
  templateUrl: './release-library-popup.component.html',
  styleUrl: './release-library-popup.component.scss',
  standalone:false
})
export class ReleaseLibraryPopupComponent implements OnInit {
  components: { buttonRenderer: any; };
  backgroundColorButton: any;
  backgroundColorScreen: any;
  buttonName = 'Save';
  FormValid!: FormGroup;
  systems: any[] = [];
  releaseTypes: any[] = [];
  releaseClassifications: any[] = [];
   //keys are lookuptype , assignTo :-  are property to which lookup need to be added
    lookups = [
      { key: "Release Type", assignTo: "releaseTypes" },
      { key: "Release Classification Rating", assignTo: "releaseClassifications"},
      // { key: "SignalSourcesV2", assignTo: "SignalSources" },
    ];
   workspaceId:any; 

  constructor(
    private fb: FormBuilder,
    public dialogref: MatDialogRef<ReleaseLibraryComponent>,
     private validation: validationmethod, 
     private localStorage: LocalStorageSettingsService,
    private commonService: CommonService,
      private spinner: NgxUiLoaderService, 
      private snackBar: MatSnackBar, 
      @Inject(MAT_DIALOG_DATA) public data: any,
      private constants: constants,

      ) {
  
    this.components = {

      buttonRenderer: Actionbutton,

    };

  }

    ngOnInit(): void {

  this.backgroundColorButton = this.localStorage.getSettings("ColorA");
  this.backgroundColorScreen = this.localStorage.getSettings("ColorD");
  this.workspaceId = Number(this.localStorage.getSettings("WorkspaceId"));
    console.log("WorkspaceID : ",this.workspaceId)

  this.buildForm();

  this.loadSystems();

  this.getAllLookupValue();

  if (this.data) {

    this.buttonName = "Update";

    this.FormValid.patchValue({

      systemId: this.data.systemId,

      releaseName: this.data.releaseName,

      releaseVersion: this.data.releaseVersion,

      releaseType: this.data.releaseType,

      releaseClassification: this.data.releaseClassification,

      releaseDescription: this.data.releaseDescription

    });

  }

}

loadSystems(){

  this.spinner.start();

  this.commonService
    .getAllComputerizedSystemLibrary(this.workspaceId)
    .subscribe({
      next: (response: any) => {

        if(response.error == true){
            this.snackBar.open(response.statusMessage, "Ok", { duration: 3000 });
            this.spinner.stop();
            console.error("Error retriving ",response.statusMessage)
            return;
          }

        this.systems = response;
        this.spinner.stop();

        if(this.systems.length == 0){
          this.snackBar.open("No system available ..please create computerized system before proceeding.","Ok", { duration: 3000 });
          this.dialogref.close();
          return;
        }
      },
      error: () => {
        this.systems = []
        this.spinner.stop();
      }
    });

}


buildForm() {

  this.FormValid = this.fb.group({

    systemId: [
      '',
      Validators.required
    ],

    releaseName: [
      '',
      [
        Validators.required,
        Validators.maxLength(200)
      ]
    ],

    releaseVersion: [
      '',
      [
        Validators.required,
        Validators.maxLength(100)
      ]
    ],

    releaseType: [
      '',
      Validators.required
    ],

    releaseClassification: [
      '',
      Validators.required
    ],

    releaseDescription: [
      '',
      Validators.maxLength(5000)
    ]

  });

}

updateData(): void {

  if (this.FormValid.invalid) {
    this.FormValid.markAllAsTouched();
    this.snackBar.open("All mandatory fields to be filled", "Ok", { duration: 3000 });
    return;
  }

  const payload = {          
    ...this.FormValid.value,
    status:"Yes",
    workspaceId:this.workspaceId
  };

  console.log("PAyload in popup : ",payload);

  this.dialogref.close({
    action: this.buttonName === 'Save' ? 'save' : 'update',
    data: payload
  });
}

close(): void {
  this.dialogref.close();
}

getAllLookupValue(){
    this.spinner.start();
     // Fetch all lookups (To add new lookup Mention In lookups[]  )
    this.lookups.forEach((lookup) => {
      this.commonService.getlookupVauleByLookUpType(lookup.key).subscribe({
        next: (result: any) => {
          console.log(`Lookup "${lookup.key}" (${lookup.assignTo}):`, result);
          // assign every lookup to its target property
          (this as any)[lookup.assignTo] = result;
          this.spinner.stop();
        },
        error: (err) => {
          console.error(`Error loading lookup "${lookup.key}":`, err);
          this.spinner.stop();
        },
      });
    });
    this.spinner.stop();
  }


}